import { useTranslation } from 'react-i18next';

import { CustomModal, CustomModalProps } from 'components/shared';
import { useErrorDescriptions } from 'constants/errorDescriptions';
import { useModal } from 'hooks/useModal';
import { HTTPService } from 'service';
import { logNetworkError } from 'utils/logNetworkError';

import styles from './UnblockClientModal.module.css';

type UnblockClientModalProps = CustomModalProps & {
   selectedUserId: string;
   onSuccessBlockClient: (userId: string) => void;
};

const UnblockClientModal = ({
   selectedUserId,
   onSuccessBlockClient,
   onClose,
   ...props
}: UnblockClientModalProps) => {
   const { t } = useTranslation();
   const { isLoading, errorInfo, setIsLoading, setErrorInfo, closeModalHandler } = useModal({
      onClose,
   });

   const { DEFAULT_ERROR_DESCRIPTIONS } = useErrorDescriptions();

   const handleUnblockClient = () => {
      setIsLoading(true);
      HTTPService.changeUserBlockedStatus(false, '', selectedUserId)
         .then(() => {
            onSuccessBlockClient(selectedUserId);
            closeModalHandler();
         })
         .catch(error => {
            setErrorInfo(DEFAULT_ERROR_DESCRIPTIONS.UNKNOWN);
            logNetworkError(error);
         })
         .finally(() => setIsLoading(false));
   };

   return (
      <CustomModal
         {...props}
         title={t('unblock_client.title')}
         error={errorInfo}
         modalContentClassName={styles.modalContent}
         isLoading={isLoading}
         leftSideModalContent
         onClose={closeModalHandler}
         primaryButtonProps={{
            text: t('unblock_client.title'),
            variant: 'filled-primary',
            onClick: handleUnblockClient,
         }}
         secondaryButtonProps={{
            text: t('common.cancel'),
            variant: 'text',
            onClick: closeModalHandler,
         }}
      >
         <>
            <p className={styles.text}>{t('unblock_client.text_1')}</p>
            <p className={styles.text}>{t('sendToSettlement.confirmationQuestion')}</p>
         </>
      </CustomModal>
   );
};

export default UnblockClientModal;
